import React, { useContext } from 'react';
import { Alert } from '@thd-olt-component-react/alert';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames/bind';
import CarPickerContext from '../../../context/CarPickerContext';
import styles from './car-picker-banner.module.scss';
import {
  formatCarDetailsToPath,
  getAlertBannerDetails,
  getVehiclePickerHistory
} from '../../car-picker-helpers';

const classes = classNames.bind(styles);

export const CarPickerBanner = () => {
  const { fitmentItems, pageType } = useContext(CarPickerContext);
  const { channel } = useContext(ExperienceContext);
  if (pageType !== 'pip') {
    return null;
  }
  const { currentVehicleSelection } = getVehiclePickerHistory();

  const NewSelection = () => {
    if (!currentVehicleSelection) {
      return <b>Please select your vehicle so we can make sure this item will fit.</b>;
    }
    return null;
  };

  let fitmentItem = fitmentItems[0] || {};
  let vehicleDetails = fitmentItem?.fitType === 'universal'
    ? '' : formatCarDetailsToPath(currentVehicleSelection).replace(/-/g, ' ');
  const { message, type } = getAlertBannerDetails(pageType, fitmentItem);
  const isMobile = channel === 'mobile';
  let bannerClasses = classes('car-picker-banner', {
    'car-picker-banner--mobile': isMobile
  });

  const AlertBanner = () => {
    if (!fitmentItems.length) {
      return null;
    }

    return (
      <div className={bannerClasses}>
        <Alert type={type} message={message}>
          <b>{vehicleDetails}</b>
        </Alert>
      </div>
    );
  };

  // TODO: Need to figure how to display banner again if user clicks X
  // TODO: Figure out when to reset i.e. dispatch({ action: 'SET_FITMENT_ITEMS', value: [] });
  //      to avoid showing new car selection details in banner while loading fitment results
  return (
    <div>
      <NewSelection />
      <AlertBanner />
    </div>
  );
};

CarPickerBanner.propTypes = {};

CarPickerBanner.defaultProps = {};

CarPickerBanner.displayName = 'CarPickerBanner';
